'use client'

import { memo } from 'react'

import { SeoListName } from 'shared/analytics'
import { useElementDimensions } from 'shared/hooks/useElementDimensions'
import OfflineNotificationLayer from 'shared/ui/Offline'

import { CartPorts } from '../ports'
import CartItemsList from '../submodules/items/components/CartItemsList'
import CartSummaryMobile from '../submodules/summary/components/CartSummaryMobile'
import { CartItem } from '../types'

import styles from './CartDrawerTabletContent.module.scss'

const MODAL_BASKET_LIST_NAME = SeoListName.MODAL_BASKET_LIST_NAME

const CartDrawerTabletContent = memo(
  ({
    productsList,
    asPath,
    isCartEditMode,
    isOnline,
    handleModalClose,
    ports
  }: {
    productsList: CartItem[]
    asPath: string
    isCartEditMode?: boolean
    isOnline: boolean
    handleModalClose: () => void
    ports: CartPorts
  }) => {
    const [mobileSummaryRef, mobileSummaryRect] =
      useElementDimensions<HTMLDivElement>()

    return (
      <div className={styles.tabletContent}>
        <div
          className={styles.cartDrawerContent}
          id='cart-drawer-content-tablet'
        >
          <CartItemsList
            className={styles.cartProductsListWrapper}
            style={
              {
                '--mobile-summary-height': `${mobileSummaryRect?.height ?? 0}px`
              } as React.CSSProperties
            }
            items={productsList}
            seoButtonPlace={asPath}
            isModal
            isCartEditMode={isCartEditMode}
            listName={MODAL_BASKET_LIST_NAME}
            ports={ports}
          />
          <CartSummaryMobile
            isCartDrawer
            handleModalClose={handleModalClose}
            ref={mobileSummaryRef}
            ports={ports}
          />

          {!isOnline && <OfflineNotificationLayer />}
        </div>
      </div>
    )
  }
)

export default CartDrawerTabletContent
